import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LandingComponent } from './landing.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () => import('@libs/landings/suncredit/components/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'borrow',
        loadChildren: () => import('@libs/landings/suncredit/components/borrow/borrow.module').then((m) => m.BorrowModule),
      },
      {
        path: 'repay',
        loadChildren: () => import('@libs/landings/suncredit/components/repay/repay.module').then((m) => m.RepayModule),
      },
      {
        path: 'about-us',
        loadChildren: () => import('@libs/landings/suncredit/components/about-us/about-us.module').then((m) => m.AboutUsModule),
      },
      {
        path: 'contacts',
        loadChildren: () => import('@libs/landings/suncredit/components/contacts/contacts.module').then((m) => m.ContactsModule),
      },
      {
        path: 'cooperation',
        loadChildren: () => import('@libs/landings/suncredit/components/cooperation/cooperation.module').then((m) => m.CooperationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingRouting {}
